import React, { FC, useId } from 'react';
import { Box, Stack, Typography } from '@mui/material';

interface Props {
  title: string;
  icon: React.ReactNode;
  status?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
}

export const SsoSection: FC<Props> = ({ title, icon, status, action, children }) => {
  const headingId = useId();
  return (
    <Box component="section" aria-labelledby={headingId}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
        <Box sx={{ color: 'text.secondary', display: 'flex' }}>{icon}</Box>
        <Typography variant="h6" component="h2" id={headingId} sx={{ fontSize: '1.05rem', fontWeight: 500 }}>
          {title}
        </Typography>
        {status}
        <Box sx={{ flexGrow: 1 }} />
        {action}
      </Stack>
      {children}
    </Box>
  );
};

export const SsoField: FC<{ label: string; value?: React.ReactNode; mono?: boolean }> = ({ label, value, mono }) => (
  <Box sx={{ minWidth: 0 }}>
    <Typography variant="caption" color="text.secondary" component="div">
      {label}
    </Typography>
    <Typography
      variant="body2"
      sx={{
        fontFamily: mono ? 'monospace' : undefined,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {value === undefined || value === null || value === '' ? '—' : value}
    </Typography>
  </Box>
);
